var r="@hpstellar/core/stock-indicator";export{r as stockIndicatorTestId};
